<template>
  <div>
    <div id="wrap">
      <h2 class="h2">高新技术企业认定</h2>
      <div class="header_box">
        <span class="span_btn">政策依据</span>
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            关于印发《高新技术企业认定管理办法》的通知<i
              class="el-icon-arrow-down el-icon--right"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="GHpolicy_a()"
              >关于印发《高新技术企业认定管理办法》的通知</el-dropdown-item
            >
            <el-dropdown-item @click.native="GHpolicy_b()"
              >国家重点支持的高新技术领域</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <div @click="centerDialogFn()" class="zice_btn">
          <span>立即自测</span>
        </div>
      </div>
      <div class="title_box">
        <span class="backg">!</span>
        <span>带*的信息尤为重要,严重影响自测结果,请您务必填写!</span>
      </div>
      <div class="answer">
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>1，企业申请认定时注册成立时间（单选）</span>
          </div>
          <div class="item">
            <!-- <el-button
              v-for="item in topic1"
              :key="item"
              :class="{ active: active == item }"
              @click="selected(item)"
              >{{ item }}</el-button
            > -->
            <el-radio
              v-for="item in topic1"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio1"
              @change="changefn1"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio1 == 0 ? '#4988df' : 'red' }"
          >
            {{ text1 }}
          </div>
        </div>
        <!--  -->
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >2，企业主要产品(服务)发挥核心支持作用的技术是否属于《国家重点支持的高新技术领域》规定的范围（单选）</span
            >
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic2"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio2"
              @change="changefn2"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio2 == 0 ? '#4988df' : 'red' }"
          >
            {{ text2 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >3，企业从事研发和相关技术创新活动的
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <div slot="content" class="tip_title">百科</div>
                <div slot="content" class="tip_content">
                  是指直接从事研发和相关技术创新活动，以及专门从事上述活动的管理和提供直接技术服务的，累计实际工作时间在183天以上的人员，包括在职、兼职和临时聘用人员。
                </div>
                <span class="keyword">科技人员</span></el-tooltip
              >
              占企业当年
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <div slot="content" class="tip_title">百科</div>
                <div slot="content" class="tip_content">
                  企业职工总数包括企业在职、兼职和临时聘用人员。在职人员可以通过企业是否签订了劳动合同或缴纳社会保险费来鉴别;兼职、临时聘用人员全年须在企业累计工作183天以上。
                </div>
                <span class="keyword">职工总数</span></el-tooltip
              >
              的比例为( )%</span
            >
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input1"
              @input="inputfn1"
            ></el-input
            ><span>（输入）</span>
          </div>
          <div
            class="title"
            :style="{ color: input1 >= 10 ? '#4988df' : 'red' }"
          >
            {{ text7 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >4，企业近三个会计年度(实际经营期不满三年的按实际经营时间计算)的研究开发费用总额占同期销售收入总额的比例(单选)</span
            >
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic3"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio3"
              @change="changefn3"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio3 != 3 ? '#4988df' : 'red' }"
          >
            {{ text3 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >5，企业在中国境内发生的研究开发费用占全部研究开发费用总额的比例为(
              )%</span
            >
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input2"
              @input="inputfn2"
            ></el-input
            ><span>（输入）</span>
          </div>
          <div
            class="title"
            :style="{ color: input2 >= 60 ? '#4988df' : 'red' }"
          >
            {{ text8 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >6，企业近一年
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <div slot="content" class="tip_title">百科</div>
                <div slot="content" class="tip_content">
                  是指企业通过研发和相关技术创新活动，取得的产品（服务）收入与技术性收入的总和。
                </div>
                <span class="keyword">高新技术产品(服务)收入</span></el-tooltip
              >
              占企业
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <div slot="content" class="tip_title">百科</div>
                <div slot="content" class="tip_content">
                  是指收入总额减去不征税收入
                </div>
                <span class="keyword">总收入</span></el-tooltip
              >
              的比例为()%</span
            >
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input3"
              @input="inputfn3"
            ></el-input
            ><span>（输入）</span>
          </div>
          <div
            class="title"
            :style="{ color: input3 >= 60 ? '#4988df' : 'red' }"
          >
            {{ text9 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >7，企业申请认定前一年内是否发生重大安全、重大质量事故或严重环境违法行为(单选)</span
            >
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic4"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio4"
              @change="changefn4"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio4 == 1 ? '#4988df' : 'red' }"
          >
            {{ text4 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >8，企业获得
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <div slot="content" class="tip_title">百科</div>
                <div slot="content" class="tip_content">
                  高新技术企业认定中，对企业知识产权情况采用分类评价方式，其中:发明专利(含国防专利)、植物新品种、国家级农作物品种、国家新药、国家—级中药保护品种、集成电路布图设计专有权等按Ⅰ类评价;实用新型专利、外观设计专利、软件著作权等（不含商标)按Ⅱ类评价。按Ⅱ类评价的知识产权在申请高新技术企业时，仅限使用一次。
                </div>
                <div slot="content" class="tip_content">
                  在申请高新技术企业及高新技术企业资格存续期内，知识产权有多个权属人时，只能由一个权属人在申请时使用。申请认定时专利的有效性以企业申请认定前获得授权证书或授权通知书并能提供缴费收据为准。
                </div>
                <span class="keyword">知识产权</span></el-tooltip
              >
              的数量为( )项</span
            >
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input4"
              @input="inputfn4"
            ></el-input
            ><span>（输入）</span>
          </div>
          <div class="title" :style="{ color: input4 > 0 ? '#4988df' : 'red' }">
            {{ text10 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>9，企业获得知识产权所有权的方式（单选)</span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic5"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio5"
              @change="changefn5"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio5 != 2 ? '#4988df' : 'red' }"
          >
            {{ text5 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>10，企业近三年科技成果转化数量为( )项</span>
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input5"
              @input="inputfn5"
            ></el-input
            ><span>（输入）</span>
          </div>
          <div class="title" :style="{ color: input5 > 0 ? '#4988df' : 'red' }">
            {{ text11 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>11，企业研究开发与技术创新组织管理情况(多选)</span>
          </div>
          <div class="item">
            <!-- <el-radio v-for="item in topic6" :key="item" v-model="radio6" :label="item" border></el-radio> -->
            <el-checkbox-group v-model="type" @change="checkboxfn">
              <el-checkbox
                v-for="item in checkbox"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div
            class="title"
            :style="{
              color: type.indexOf(4) < 0 ? '#4988df' : 'red',
            }"
          >
            {{ text6 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >12，企业近三年
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <div slot="content" class="tip_title">百科</div>
                <div slot="content" class="tip_content">
                  净资产增长率=1/2(第二年末净资产÷第一年末净资产＋第三年末净资产÷第二年末净资产)-
                  1<br />净资产=资产总额–负债总额
                </div>
                <span class="keyword">净资产增长率</span></el-tooltip
              >
              为( )%(企业实际经营期不满三年的按实际经营时间计算)</span
            >
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input6"
              @input="inputfn6"
            ></el-input
            ><span>（输入）</span>
          </div>
          <div
            class="title"
            :style="{ color: input6 >= 1 ? '#4988df' : 'red' }"
          >
            {{ text12 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >13，企业近三年销售收入增长率为( )
              %(企业实际经营期不满三年的按实际经营时间计算)
            </span>
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input7"
              @input="inputfn7"
            ></el-input
            ><span>（输入）</span>
          </div>
          <div
            class="title"
            :style="{ color: input7 >= 1 ? '#4988df' : 'red' }"
          >
            {{ text13 }}
          </div>
        </div>
      </div>
      <div class="flex flex-center">
        <div @click="centerDialogFn()" class="zice_btn">
          <span>立即自测</span>
        </div>
      </div>
    </div>

    <el-dialog
      title="自测结果"
      :visible.sync="centerDialogVisible"
      class="ziceDialog"
      center
    >
      <div class="text_box">
        根据您的数据，您的匹配度为:
        <h2 class="restitle" style="display: inline" id="status">
          {{ status }}
        </h2>
      </div>
      <br />
      <div class="flex flex-center">
        <img src="@images/icon/res.png" alt="" />
      </div>
      <h2 class="restitle" style="text-align: center" id="msg1">{{ msg1 }}</h2>
      <div id="msg2" class="subtitle" style="margin-top: 15px">
        {{ msg2 }}
      </div>
      <br />
      <div style="font-size: 12px; text-align: center">
        <span style="color: red">温馨提示:</span>
        <span style="color: darkgray"
          >政策自测结果仅供参考，请申报单位参考当地申报通知进行申报</span
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false"
          >确认</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="计算中"
      :visible.sync="centerDialogVisible2"
      width="26%"
      center
    >
      <div class="flex flex-center zice_gif">
        <img src="@images/icon/zice.gif" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import axios from 'axios';
// import { $ } from "jquery";
import { zice } from "./index";
export default {
  data() {
    return {
      msg1: "",
      msg2: "",
      accordScore: 145,
      status: "",
      centerDialogVisible: false,
      centerDialogVisible2: false,
      topic1: [
        { label: "大于一年", value: 0 },
        { label: "小于等于一年", value: 1 },
      ],
      topic2: [
        { label: "属于", value: 0 },
        { label: "不属于", value: 1 },
      ],
      topic3: [
        { label: "最近一年销售收入在2亿元以上的企业,比例不低于3%", value: 0 },
        {
          label: "最近一年销售收入在5,000万元至2亿元(含)的企业,比例不低于4%",
          value: 1,
        },
        {
          label: "最近一年销售收入小于5,000万元(含)的企业,比例不低于5%",
          value: 2,
        },
        { label: "以上都不满足", value: 3 },
      ],
      topic4: [
        { label: "发生", value: 0 },
        { label: "未发生", value: 1 },
      ],
      topic5: [
        { label: "有自主研发", value: 0 },
        { label: "仅有受让，受赠和并购等", value: 1 },
        { label: "以上皆无", value: 2 },
      ],
      topic6: [
        {
          label:
            "制定了企业研究开发的组只管理制度,建立了研发投入核算体系,编制了研发费用辅助账",
          value: 0,
        },
        {
          label:
            "设立了内部科学技术研究开发机构并具备相应的科研条件,与国内外研究开发机构开展多种形式产学研合作",
          value: 1,
        },
        {
          label:
            "建立了科技成果转化的组织实施与激励奖励制度,建立开放式的创新创业平台",
          value: 2,
        },
        {
          label:
            "建立了科技人员的培养进修、职工技能培训、优秀人才引进,以及人才绩效评价奖励制度",
          value: 3,
        },
        { label: "以上皆不是", value: 4 },
      ],
      // 单选
      radio1: 9,
      radio2: 9,
      radio3: 9,
      radio4: 9,
      radio5: 9,
      // 多选
      // {label:'',value:''}
      type: [],
      checkbox: [
        {
          label:
            "制定了企业研究开发的组只管理制度,建立了研发投入核算体系,编制了研发费用辅助账",
          value: 0,
        },
        {
          label:
            "设立了内部科学技术研究开发机构并具备相应的科研条件,与国内外研究开发机构开展多种形式产学研合作",
          value: 1,
        },
        {
          label:
            "建立了科技成果转化的组织实施与激励奖励制度,建立开放式的创新创业平台",
          value: 2,
        },
        {
          label:
            "建立了科技人员的培养进修、职工技能培训、优秀人才引进,以及人才绩效评价奖励制度",
          value: 3,
        },
        {
          label: "以上皆不是",
          value: 4,
        },
      ],
      // 提示信息
      text1: "",
      text2: "",
      text3: "",
      text4: "",
      text5: "",
      text6: "",
      text7: "",
      text8: "",
      text9: "",
      text10: "",
      text11: "",
      text12: "",
      text13: "",

      // 输入框
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      input5: "",
      input6: "",
      input7: "",

      info: "",
      time: "",
    };
  },
  created() {
    this.initialize();
    // axios
    //   .get("http://192.168.0.100:8080/meter/addMeterRecord")
    //   .then((response) => (this.info = response));
  },
  methods: {
    initialize: function () {},
    typefn: function () {
      this.accordScore = 151;
      zice(1).then((res) => {
        console.log(res);
      });

      if (this.radio1 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio2 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio3 == 3) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio4 == 0) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio5 == 2) {
        this.accordScore = parseInt(this.accordScore) - 206;
      }
      if (this.radio5 == 1) {
        this.accordScore = parseInt(this.accordScore) - 5;
      }
      if (this.type.indexOf(4) > -1) {
        this.accordScore = parseInt(this.accordScore) - 220;
        if (this.type.indexOf(0) > -1) {
          this.accordScore = parseInt(this.accordScore) + 6;
        }
        if (this.type.indexOf(1) > -1) {
          this.accordScore = parseInt(this.accordScore) + 6;
        }
        if (this.type.indexOf(2) > -1) {
          this.accordScore = parseInt(this.accordScore) + 4;
        }
        if (this.type.indexOf(3) > -1) {
          this.accordScore = parseInt(this.accordScore) + 4;
        }
      } else {
        if (this.type.indexOf(0) < 0) {
          this.accordScore = parseInt(this.accordScore) - 6;
        }
        if (this.type.indexOf(1) < 0) {
          this.accordScore = parseInt(this.accordScore) - 6;
        }
        if (this.type.indexOf(2) < 0) {
          this.accordScore = parseInt(this.accordScore) - 4;
        }
        if (this.type.indexOf(3) < 0) {
          this.accordScore = parseInt(this.accordScore) - 4;
        }
      }
      if (this.input1 < 10) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.input2 < 60) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.input3 < 60) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.input4 >= 1 && this.input4 <= 2) {
        this.accordScore = parseInt(this.accordScore) - 4;
      }
      if (this.input4 >= 3 && this.input4 <= 4) {
        this.accordScore = parseInt(this.accordScore) - 2;
      }
      if (this.input4 <= 0) {
        this.accordScore = parseInt(this.accordScore) - 205;
      }
      if (this.input5 <= 3 && this.input5 >= 1) {
        this.accordScore = parseInt(this.accordScore) - 29;
      }
      if (this.input5 <= 6 && this.input5 >= 4) {
        this.accordScore = parseInt(this.accordScore) - 23;
      }
      if (this.input5 <= 9 && this.input5 >= 7) {
        this.accordScore = parseInt(this.accordScore) - 17;
      }
      if (this.input5 <= 12 && this.input5 >= 10) {
        this.accordScore = parseInt(this.accordScore) - 11;
      }
      if (this.input5 <= 14 && this.input5 >= 13) {
        this.accordScore = parseInt(this.accordScore) - 5;
      }
      if (this.input5 <= 0) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }

      if (this.input6 <= 0) {
        this.accordScore = parseInt(this.accordScore) - 10;
      }
      if (this.input6 <= 34 && this.input6 > 0) {
        this.accordScore = parseInt(this.accordScore) - 8;
      }
      if (this.input7 <= 0) {
        this.accordScore = parseInt(this.accordScore - 10);
      }
      if (this.input7 <= 34 && this.input7 > 0) {
        this.accordScore = parseInt(this.accordScore) - 8;
      }
      console.log(this.accordScore);
      if (this.accordScore > 0 && this.accordScore <= 140) {
        this.status = "中";
        this.msg1 = "哎呀,差一点!";
        this.msg2 = "您的自测值为中等,申报有风险";
      } else if (this.accordScore >= 141 && this.accordScore <= 151) {
        this.status = "高";
        this.msg1 = "太棒了，恭喜您!";
        this.msg2 = "根据测评结果，建议申报！";
      } else if (this.accordScore < 0) {
        this.status = "低";
        this.msg1 = "再接再厉!";
        this.msg2 =
          "您的自测分值较低，未达到申报基本条件，尝试其他项目或完善信息吧！";
      }
    },

    // 自测弹出框
    centerDialogFn() {
      if (
        this.radio1 == 9 ||
        this.radio2 == 9 ||
        this.radio3 == 9 ||
        this.radio4 == 9 ||
        this.radio5 == 9 ||
        this.input1 == "" ||
        this.input2 == "" ||
        this.input3 == "" ||
        this.input4 == "" ||
        this.input5 == "" ||
        this.input6 == "" ||
        this.input7 == "" ||
        this.type.length <= 0
      ) {
        this.$message.error("请将带*的题目填写完成");
      } else {
        this.typefn();
        this.centerDialogVisible2 = true;
        this.time = setTimeout(this.timer, 3000);
      }
    },
    timer: function () {
      this.centerDialogVisible2 = false;
      this.centerDialogVisible = true;
    },

    GHpolicy_a: function () {
      this.$router.push("/centerForm/GHpolicy_a");
    },
    GHpolicy_b: function () {
      this.$router.push("/centerform/GHpolicy_b");
    },
    changefn1: function (e) {
      console.log(e);
      if (e == 0) {
        this.text1 = "注: 符合";
      } else if (e == 1) {
        this.text1 = "注: 不符合，企业申请认定时须注册成立一年以上。";
      }
    },
    changefn2: function (e) {
      console.log(e);
      if (e == "0") {
        this.text2 = "注: 符合";
      } else if (e == "1") {
        this.text2 =
          "注: 不符合，要求企业主要技术须在《国家重点支持的高新技术领域》规定的范围内。";
      }
    },
    changefn3: function (e) {
      console.log(e);
      if (e == "3") {
        this.text3 =
          "注: 不符合，企业近三个会计年度（实际经营期不满三年的按实际经营时间计算）的研究开发费用总额占同期销售收入总额的比例符合相应要求。";
      } else {
        this.text3 = "注：符合";
      }
    },
    changefn4: function (e) {
      console.log(e);
      if (e == "1") {
        this.text4 = "注: 符合";
      } else if (e == "0") {
        this.text4 =
          "注: 不符合，企业申请认定前一年内，不能存在重大安全事故以及违法行为。";
      }
    },
    changefn5: function (e) {
      console.log(e);
      if (e == "0") {
        this.text5 = "注: 符合";
      } else if (e == "1") {
        this.text5 = "注: 基本符合";
      } else if (e == "2") {
        this.text5 =
          "注: 不符合，企业须通过自主研发、受让、受赠、并购等方式，获得对其主要产品（服务）在技术上发挥核心支持作用的知识产权的所有权。";
      }
    },

    inputfn1: function (e) {
      console.log(this.input1);
      if (parseInt(e) < 10) {
        this.text7 =
          "注: 不符合，要求企业从事研发和相关技术创新活动的科技人员占企业当年职工总数的比例不低于10%。";
      } else if (parseInt(e) >= 10 && parseInt(e) <= 100) {
        this.text7 = "注：符合";
      } else {
        this.text7 = "";
      }
    },
    inputfn2: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) < 60) {
        this.text8 =
          "注: 不符合，要求企业在中国境内发生的研究开发费用总额占全部研究开发费用总额的比例不低于60%。";
      } else if (parseInt(e) >= 60 && parseInt(e) <= 100) {
        this.text8 = "注：符合";
      } else {
        this.text8 = "";
      }
    },
    inputfn3: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) < 60) {
        this.text9 =
          "注: 不符合，要求企业近一年高新技术产品(服务)收入占企业周期总收入的比例不低于60%。";
      } else if (parseInt(e) >= 60 && parseInt(e) <= 100) {
        this.text9 = "注：符合";
      } else {
        this.text9 = "";
      }
    },
    inputfn4: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) <= 0) {
        this.text10 =
          "注: 不符合,须申请5项及以上知识产权(专利、计算机软件著作权)";
      } else if (parseInt(e) < 5 && parseInt(e) > 0) {
        this.text10 =
          "基本符合，建议申请5项及以上知识产权（专利、计算机软件著作权）";
      } else if (parseInt(e) >= 5) {
        this.text10 = "注:符合";
      }
    },
    inputfn5: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) <= 0) {
        this.text11 = "注:不符合,建议进行15项以上成果转化";
      } else if (parseInt(e) >= 1 && parseInt(e) < 15) {
        this.text11 = "注：基本符合,建议进行15项以上成果转化";
      } else if (parseInt(e) >= 15) {
        this.text11 = "注:符合";
      }
    },
    inputfn6: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) <= 0) {
        this.text12 = "注: 不符合,企业近三年净资产增长率应大于0";
      } else if (parseInt(e) <= 34) {
        this.text12 = "注：基本符合";
      } else if (parseInt(e) >= 35) {
        this.text12 = "注:符合";
      }
    },
    inputfn7: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) <= 0) {
        this.text13 = "注: 不符合,企业近三年销售收入增长率应该大于0";
      } else if (parseInt(e) <= 34) {
        this.text13 = "注：基本符合";
      } else if (parseInt(e) >= 35) {
        this.text13 = "注:符合";
      }
    },
    checkboxfn: function (e) {
      if (e.indexOf(4) > -1) {
        this.type = [4];
        this.text6 = "注: 不符合，须至少满足以上选项条件里的一项。";
        // } else if (e == false) {
        //   this.text6 = "";
      } else {
        this.text6 = "注: 符合";
      }
    },
  },
};
</script>

<style scoped>
.h2 {
  color: #4988df;
}
.header_box {
  padding-bottom: 20px;
  border-bottom: 2px solid #4988df;
}
.span_btn {
  padding: 5px;
  border: 1px solid #4988df;
  color: #4988df;
  margin-right: 10px;
}
.zice_btn {
  color: #fff;
  background: #4988df;
  padding: 8px 22px;
  border-radius: 3px;
  float: right;
}
.title_box {
  margin-top: 15px;
  padding: 10px;
  border: 1px solid #f8cf96;
  background: #fff9ec;
}
.title_box .backg {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  color: #fff;
  margin-right: 10px;
  background: #efc28a;
}
.answer {
  padding: 18px;
  font-size: 15px;
}
.answer .color {
  color: #d16963;
}
.answer .item {
  margin-left: 30px;
  /* margin-top: 15px; */
}
.answer .el-radio,
.answer .el-input,
.answer .el-checkbox {
  margin-top: 15px;
}
.answer .item_box {
  padding: 20px 0;
  border-bottom: 1px solid #dbdbdb;
}
.answer .el-button {
  margin-bottom: 10px;
}
.active {
  background-color: #d16963;
  color: #fff;
}
.restitle {
  margin: 15px 0 0 30px;
  color: #c40311;
}
.tip_title {
  color: #4988df;
  font-weight: bold;
}
.tip_content {
  font-size: 15px;
}
.keyword {
  margin-left: 5px !important;
  color: #4988df;
}
.subtitle {
  margin: 15px 0 0 20px;
  text-align: center;
}
.title {
  margin: 15px 0 0 30px;
  color: #c40311;
}

.el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0 !important;
}
</style>
